import { render } from "./Header.vue?vue&type=template&id=fae02ab8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=fae02ab8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fae02ab8"

export default script